module.exports = require("libphonenumber-js");